import * as eventTypes from "./eventTypes";
import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function computeFolderNextStatesList(documentId, siteId) {
  return async (dispatch, getState) => {
    const nextStates = getState().currentFolder.nextStates;
    if (nextStates.isLoaded || nextStates.loading) {
      return;
    }

    try {
      dispatch({ type: actionTypes.COMPUTE_FOLDER_NEXT_STATES_STARTED });

      await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.computeFolderNextStatesList(documentId, siteId),
          "ComputeFolderNextStatesListInProgress",
          [eventTypes.FOLDER_NEXT_STATES_LIST_COMPUTED],
          false
        )
      );
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateFolderState(documentId, siteId, newStateId, facilityId, callback = () => {}) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.updateFolderState(documentId, siteId, newStateId, facilityId),
          "UpdateFolderStateInProgress",
          [eventTypes.FOLDER_STATE_UPDATED]
        )
      );
      if (event.ok)
       callback();
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
